import get from 'lodash/get';
import {
  validationObject,
  validateRequired,
  validateName,
  validateDuration,
} from 'utils/validations';
import timezones from 'static/timezones.json';
import { SITE_POLICY_DEFAULT_VALUES } from 'utils/constants/visitor';
import {
  getFormInitialValues,
  optionalFormField,
  translateValue,
} from 'utils/methods/helpers';
import { siteFields } from 'utils/SiteFormFields';
import {
  contactValidation,
  businessClientValidation,
  siteBaseValidation,
} from 'utils/validationSchema/index.js';
import { USER_FIELDS } from 'utils/formFields/user';
import BusinessClientForm from 'containers/Pages/People/BusinessClients/form';
import ClientForm from 'containers/Pages/People/Customers/Layouts/CustomerForm';
// import { SiteInfo } from 'utils/constants/informationText';
import API from 'services/api';
import { ROLES } from 'utils/constants';

import isEmpty from 'lodash/isEmpty';
import { transformRaw } from 'utils/DataTransform/Personnel/PersonnelList';
// import { SiteInfo } from 'utils/constants/informationText';

const patrolValidation = scheduledRequired => {
  let validation = {
    checkpoints: validateRequired(),
    patrolTimezone: validateRequired(),
    patrolDefinitionName: validateName(30),
    expectedDuration: validateDuration(false, 4),
  };
  if (scheduledRequired) {
    validation = {
      ...validation,
      interval: validateRequired(),
      startTime: validateRequired(),
      endTime: validateRequired(),
    };
  }
  return validation;
};

export const validationSchema = ({
  addBusinessClient,
  addContact,
  addPatrol,
  scheduledRequired,
  addSiteContact,
}) => {
  let validation = siteBaseValidation;
  if (addBusinessClient) {
    validation = { ...validation, ...businessClientValidation };
    Reflect.deleteProperty(validation, 'businessClient');
  }
  if (addContact) {
    validation = { ...validation, ...contactValidation };
  }
  if (addSiteContact) {
    validation = { ...validation, ...contactValidation };
  }

  if (addPatrol) {
    validation = {
      ...validation,
      ...patrolValidation(scheduledRequired),
    };
  }

  return validationObject(validation);
};

export const initialValues = (data, businessClientEmbeddedDetails) => {
  const initial = getFormInitialValues(data);
  return {
    ...initial,
    paths: get(initial, 'locations[0].paths', []),
    businessClients: businessClientEmbeddedDetails,
  };
};

export const initialState = initTimezone => ({
  siteId: undefined,
  name: undefined,
  address: undefined,
  inductionRequired: false,
  timezone: initTimezone,
  businessClient: '',
  contact: null,
  businessClientId: '',
  businessClientAddress: undefined,
  ...SITE_POLICY_DEFAULT_VALUES,
});

export const generalSection = ({
  securityCompanyId,
  selectedBusinessClient,
  addBusinessClient,
  userAssignedDepartments = [],
  updatedValues,
  selectedDepartments,
}) => {
  const { siteId, siteName, timezone } = siteFields;
  return [
    siteId,
    siteName,
    {
      field: 'businessClient',
      type: 'async-select',
      // info: SiteInfo.businessClient, FIX-ME- crashes on enable
      required: true,
      size: 'half',
      valueType: 'object',
      fetchOptions: API.fetchBusinessClientList,
      fetchFilters: {
        securityCompanyId,
        archived: false,
        ...(!isEmpty(selectedDepartments) && {
          departmentId: selectedDepartments
            .map(m => ({ id: m.id }))
            .map(m => m.id),
        }),
      },
      optionLabelKey: 'name',
      resetWhen: [
        {
          value: selectedDepartments,
          condition: val => {
            return val; // have to reset business clients when ever departments are selected or deselected
          },
        },
      ],
      dataTransform: ({ data }) => {
        return data;
      },
    },
    {
      field: 'businessClient', // this field name should be same as the one you are trying to replace value with
      type: 'embedded-form-follow-up',
      label: 'New Business Client',
      component: BusinessClientForm,
      archiveDelete: true,
      updatedValues,
      hideTable: true,
      componentProps: {
        embeddedForm: true,
        disablePresist: true,
      },
    },
    {
      field: 'contact',
      label: 'Site Contact',
      // info: SiteInfo.contact,
      type: 'async-select',
      disabled: !selectedBusinessClient || addBusinessClient,
      size: 'half',
      fetchOptions: API.fetchUserList,
      fetchFilters: {
        securityCompanyId,
        roles: [ROLES.CLIENT.id],
        archived: false,
        businessClientId: selectedBusinessClient?.id,
      },
      optionLabelKey: 'label',
      dataTransform: ({ data }) => {
        return transformRaw(data);
      },
      resetWhen: [
        {
          value: selectedBusinessClient,
          condition: val => {
            return val; // reset when business client is selected
          },
        },
      ],
    },
    {
      field: 'contact',
      type: 'embedded-form-follow-up',
      label: `${translateValue('status_new_enum')} ${translateValue(
        'Site Contact',
      )}`,
      disabled: !selectedBusinessClient || addBusinessClient,
      component: ClientForm,
      archiveDelete: true,
      updatedValues,
      hideTable: true,
      componentProps: {
        embeddedForm: true,
        disablePresist: true,
        embeddedselectedBusinessClient: selectedBusinessClient,
      },
    },
    { ...timezone({ timezones }), size: 'half' },
    ...optionalFormField({
      showWhen: userAssignedDepartments.length > 0,
      field: USER_FIELDS.departments({
        userAssignedDepartments,
      }),
    }),
  ];
};

export const detailedSection = ({ toggleManageVisitor, visitor }) => {
  const { sitePolicy, locations, manageVisitor, address } = siteFields;
  return [
    visitor ? manageVisitor : [],
    sitePolicy({ hidden: toggleManageVisitor }),
    address,
    locations,
  ];
};
